import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RideTripsDetailScreen from './screens/RideTripsDetailScreen';
import RideTripsListScreen from './screens/RideTripsListScreen';

function RideTrips() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RideTripsListScreen />} />
          <Route path=":tripId" element={<RideTripsDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RideTrips;
